/*
 * LUKACHARI — product gallery colour filter (Claude 17.09.2026)
 *
 * The master products hold every colour in one product, so the gallery would show
 * all nine colours at once before the customer picks anything. This keeps only the
 * media of the selected colour visible, in the gallery and in the thumbnails, and
 * updates it whenever the colour changes.
 *
 * A media whose colour cannot be read from its alt text or file name, such as a
 * fabric macro or a size chart, always stays visible. On a product with no colour
 * option nothing here runs.
 *
 * 01.11.2026 fix: the theme keeps Flickity at window.theme.Flickity, not window.Flickity,
 * so the carousel was never re-measured after a colour change. The main image area fell
 * to height 0 (only a thumbnail left) and the page jumped up and down by ~450px on every
 * colour tap. Now the carousel only counts the visible cells and keeps its height.
 */
(function() {
  var COLORS = [
    ['אוף וויט', ['אוף וויט', 'off-white', 'offwhite', 'off_white']],
    ['אפור כהה', ['אפור כהה', 'dark grey', 'darkgrey', 'dark-grey', 'dark_grey']],
    ['אפור בהיר', ['אפור בהיר', 'light grey', 'lightgrey', 'light-grey', 'light_grey']],
    ['נייבי', ['נייבי', 'navy']],
    ['חום', ['חום', 'brown']],
    ['בז׳', ['בז', 'beige']],
    ['כחול', ['כחול', 'blue']],
    ['שחור', ['שחור', 'black']],
    ['לבן', ['לבן', 'white']]
  ];

  var STYLE_ID = 'lk-gallery-filter-style';
  var CELL_SELECTOR = '[data-product-slide]:not(.lk-media-filtered)';

  function ensureStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = '.lk-media-filtered{display:none !important;}';
    document.head.appendChild(s);
  }

  function colorFromText(text) {
    var hay = (text || '').toLowerCase();
    for (var i = 0; i < COLORS.length; i++) {
      for (var j = 0; j < COLORS[i][1].length; j++) {
        if (hay.indexOf(COLORS[i][1][j]) !== -1) return COLORS[i][0];
      }
    }
    return '';
  }

  function isKnownColor(value) {
    for (var i = 0; i < COLORS.length; i++) {
      if (COLORS[i][0] === value) return true;
    }
    return false;
  }

  function mediaColor(node) {
    if (node.getAttribute('data-lk-color') !== null) {
      return node.getAttribute('data-lk-color');
    }
    var img = node.querySelector('img');
    var text = '';
    if (img) {
      text = (img.getAttribute('alt') || '') + ' ' + (img.getAttribute('src') || img.getAttribute('data-src') || '');
    }
    if (!text.trim()) {
      var link = node.querySelector('a[href]');
      if (link) text = link.getAttribute('href');
    }
    var found = colorFromText(text);
    node.setAttribute('data-lk-color', found);
    return found;
  }

  // Finds the option group that carries the colour, by looking at the values themselves.
  function colorIndex(root) {
    var cached = root.getAttribute('data-lk-color-index');
    if (cached) return cached;
    var inputs = root.querySelectorAll('input[data-index], select[data-index]');
    var score = {};
    for (var i = 0; i < inputs.length; i++) {
      var idx = inputs[i].getAttribute('data-index');
      var values = [];
      if (inputs[i].tagName === 'SELECT') {
        for (var o = 0; o < inputs[i].options.length; o++) values.push(inputs[i].options[o].value);
      } else {
        values.push(inputs[i].value);
      }
      for (var v = 0; v < values.length; v++) {
        if (isKnownColor((values[v] || '').trim())) {
          score[idx] = (score[idx] || 0) + 1;
        }
      }
    }
    var best = '', bestScore = 0;
    for (var k in score) {
      if (score[k] > bestScore) { bestScore = score[k]; best = k; }
    }
    if (bestScore < 2) return '';
    root.setAttribute('data-lk-color-index', best);
    return best;
  }

  function selectedColor(root, idx) {
    var checked = root.querySelector('input[data-index="' + idx + '"]:checked');
    if (checked && checked.value) return checked.value.trim();
    var select = root.querySelector('select[data-index="' + idx + '"]');
    if (select && select.value) return select.value.trim();
    var first = root.querySelector('input[data-index="' + idx + '"]');
    return first && first.value ? first.value.trim() : '';
  }

  // The theme ships Flickity as window.theme.Flickity; window.Flickity is kept as a fallback.
  function flickityLib() {
    if (window.theme && window.theme.Flickity && window.theme.Flickity.data) return window.theme.Flickity;
    if (window.Flickity && window.Flickity.data) return window.Flickity;
    return null;
  }

  function carousels(root) {
    var F = flickityLib();
    var out = [];
    if (!F) return out;
    var sliders = root.querySelectorAll('[data-product-single-media-slider]');
    for (var i = 0; i < sliders.length; i++) {
      var flkty = F.data(sliders[i]);
      if (flkty) out.push(flkty);
    }
    return out;
  }

  // True when the carousel still counts a hidden cell (its height then falls to 0).
  function stale(root) {
    var list = carousels(root);
    for (var i = 0; i < list.length; i++) {
      var cells = list[i].cells || [];
      if (list[i].options.cellSelector !== CELL_SELECTOR) return true;
      for (var c = 0; c < cells.length; c++) {
        if (cells[c].element && cells[c].element.classList.contains('lk-media-filtered')) return true;
      }
    }
    return false;
  }

  // If the gallery runs as a Flickity carousel, it has to re-measure after cells are hidden.
  function refreshCarousels(root) {
    var list = carousels(root);
    for (var i = 0; i < list.length; i++) {
      var flkty = list[i];
      try {
        flkty.options.cellSelector = CELL_SELECTOR;
        flkty.reloadCells();
        flkty.resize();
        flkty.select(0, false, true);
      } catch (e) {}
    }
  }

  function apply(root) {
    var idx = colorIndex(root);
    if (!idx) return;
    var color = selectedColor(root, idx);
    if (!color || !isKnownColor(color)) return;
    var nodes = root.querySelectorAll('[data-product-slide], .product-single__thumbnail');
    if (!nodes.length) return;
    var changed = false;
    for (var i = 0; i < nodes.length; i++) {
      var own = mediaColor(nodes[i]);
      var hide = own !== '' && own !== color;
      if (hide !== nodes[i].classList.contains('lk-media-filtered')) changed = true;
      if (hide) {
        nodes[i].classList.add('lk-media-filtered');
      } else {
        nodes[i].classList.remove('lk-media-filtered');
      }
    }
    if (changed || stale(root)) refreshCarousels(root);
  }

  function roots() {
    var list = document.querySelectorAll('product-info, [data-product-single-media-group]');
    var out = [];
    for (var i = 0; i < list.length; i++) {
      var r = list[i];
      if (r.querySelector('[data-product-slide]') && r.querySelector('input[data-index], select[data-index]')) {
        out.push(r);
      }
    }
    return out;
  }

  var resizeTimer = null;

  function run() {
    ensureStyle();
    var list = roots();
    for (var i = 0; i < list.length; i++) {
      var root = list[i];
      apply(root);
      if (root.lkGalleryBound) continue;
      root.lkGalleryBound = true;
      root.addEventListener('change', function() {
        var self = this;
        apply(self);
        setTimeout(function() { apply(self); }, 0);
        setTimeout(function() { apply(self); }, 400);
      });
      root.addEventListener('click', function() {
        var self = this;
        setTimeout(function() { apply(self); }, 50);
      });
      if (window.MutationObserver) {
        (function(node) {
          var observer = new MutationObserver(function() {
            if (node.lkBusy) return;
            node.lkBusy = true;
            setTimeout(function() { node.lkBusy = false; apply(node); }, 120);
          });
          observer.observe(node, { childList: true, subtree: true });
        })(root);
      }
    }
  }

  run();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('variant:change', run);
  document.addEventListener('theme:variant:change', run);
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(run, 250);
  });
})();
